import React from "react";

function redirect() {
  window.location = "https://home.moti.bio";
  return <div></div>;
}

export default redirect;
